/**
 * /:lang/blog/:slug as a LAZY route: the article page and every article body
 * (src/lib/blogPosts.ts) download only here, not with the app shell.
 * vite-react-ssg prerenders it and loads this module before hydrating.
 */
import { useLocation } from 'react-router-dom';
import { MarketingGate } from '@/components/maintenance/MaintenanceGates';
import { SUPPORTED_LANGS, type BlogLang } from '@/lib/blogLangs';
import BlogPostPage from './BlogPostPage';

export function Component() {
  const { pathname } = useLocation();
  const first = pathname.split('/').filter(Boolean)[0] as BlogLang | undefined;
  const lang: BlogLang = first && SUPPORTED_LANGS.includes(first) ? first : 'hr';
  return (
    <MarketingGate>
      <BlogPostPage langOverride={lang} />
    </MarketingGate>
  );
}

export default Component;
